module.exports = __webpack_public_path__ + "static/media/snow-day.67d63a14.svg";